/* file: assets/j_cart-gifts.js */

/******* CART GIFTS: BUY X GET GIFT (ES5, AJAX, PRIORITY, CAPS, ACCESS, DEBUG) *******/

/* ===== 0) LOG TOGGLES ===== */
var JCG_DEBUG = true;  // normal logs
var JCG_TRACE = true;  // extra diagnostics

function jcgLog(level) {
  if (!JCG_DEBUG) return;
  var args = Array.prototype.slice.call(arguments, 1);
  (console[level] || console.log).apply(console, ['[JCG]'].concat(args));
}
function jcgTrace() {
  if (!JCG_TRACE) return;
  var args = Array.prototype.slice.call(arguments);
  console.log.apply(console, ['[JCG:TRACE]'].concat(args));
}

/* ===== TOAST POPUP ===== */
var __jcgToastEl = null;
var __jcgToastTimer = null;

function jcgEnsureToast() {
  if (__jcgToastEl) return __jcgToastEl;

  var el = document.createElement('div');
  el.id = 'jcg-toast';
  el.setAttribute('aria-live', 'polite');
  el.setAttribute('aria-atomic', 'true');
  el.style.position = 'fixed';
  el.style.left = '50%';
  el.style.bottom = '24px';
  el.style.transform = 'translateX(-50%)';
  el.style.zIndex = '999999';
  el.style.maxWidth = '92vw';
  el.style.display = 'none';

  el.innerHTML = ''
    + '<div id="jcg-toast-inner" style="'
    + 'background:#111;color:#fff;padding:12px 14px;border-radius:10px;'
    + 'box-shadow:0 10px 30px rgba(0,0,0,.25);'
    + 'font-size:13px;line-height:1.3;display:flex;align-items:center;gap:10px;">'
    + '<span id="jcg-toast-text">Gift added automatically.</span>'
    + '<button type="button" id="jcg-toast-close" aria-label="Close" style="'
    + 'margin-left:auto;background:transparent;border:0;color:#fff;'
    + 'font-size:18px;line-height:1;cursor:pointer;padding:0;">×</button>'
    + '</div>';

  document.body.appendChild(el);

  var closeBtn = el.querySelector('#jcg-toast-close');
  if (closeBtn) {
    closeBtn.addEventListener('click', function () { jcgHideToast(); });
  }

  __jcgToastEl = el;
  return el;
}

function jcgShowToast(text, ms) {
  if (!text) text = 'Gift added automatically.';
  if (typeof ms !== 'number') ms = 2200;

  var el = jcgEnsureToast();
  var t = el.querySelector('#jcg-toast-text');
  if (t) t.textContent = text;

  el.style.display = 'block';
  el.style.opacity = '0';
  el.style.transition = 'opacity 180ms ease';
  setTimeout(function () { el.style.opacity = '1'; }, 10);

  if (__jcgToastTimer) clearTimeout(__jcgToastTimer);
  __jcgToastTimer = setTimeout(function () { jcgHideToast(); }, ms);
}

function jcgHideToast() {
  if (!__jcgToastEl) return;
  __jcgToastEl.style.opacity = '0';
  setTimeout(function () {
    if (__jcgToastEl) __jcgToastEl.style.display = 'none';
  }, 180);
}


/* ===== 1) SINGLETON CART FETCH + DEBOUNCE ===== */
var __jcgRefreshTimer = null;
var __jcgCartFetchInFlight = null;

function jcgDebouncedRefresh(delay) {
  if (typeof delay !== 'number') delay = 120;
  if (__jcgRefreshTimer) cancelAnimationFrame(__jcgRefreshTimer);
  __jcgRefreshTimer = requestAnimationFrame(function () {
    setTimeout(function () { jcgRefresh(); }, delay);
  });
}

function jcgGetCart() {
  if (__jcgCartFetchInFlight) return __jcgCartFetchInFlight;
  __jcgCartFetchInFlight = fetch('/cart.js', { credentials: 'same-origin' })
    .then(function (r) { return r.json(); })
    .catch(function (err) { jcgLog('error', 'GET /cart.js failed', err); throw err; })
    .finally(function () { __jcgCartFetchInFlight = null; });
  return __jcgCartFetchInFlight;
}

/* ===== 2) DOM + DATA PARSE ===== */
var jcgRefs = {
  container: null,
  rules: [],
  giftCap: 0,
  customerLogged: null,
  globalDebug: false
};

function jcgInitRefs(force) {
  if (jcgRefs.container && force !== true) {
    try { if (document.body.contains(jcgRefs.container)) return; } catch (_) {}
  }

  jcgRefs.container = document.querySelector('.j_cg-container') || null;
  if (!jcgRefs.container) return;

  var ds = jcgRefs.container.dataset || {};
  jcgRefs.giftCap = parseInt(ds.giftCap || '0', 10) || 0;
  jcgRefs.customerLogged = (String(ds.customerLogged || '').toLowerCase() === 'true');
  jcgRefs.globalDebug = (String(ds.debug || '').toLowerCase() === 'true');

  // If container enables debug, turn on logs for this instance
  if (jcgRefs.globalDebug) {
    JCG_DEBUG = true;
    JCG_TRACE = true;
  }

  // rules
  var raw = ds.rules || '';
  var parsed = [];
  if (raw) {
    try { parsed = JSON.parse(raw); }
    catch (e) { jcgLog('error', 'data-rules parse failed', e, raw); parsed = []; }
  }

  if (!Array.isArray(parsed)) parsed = [];

  // normalize + filter enabled
  parsed = parsed.filter(function (r) { return r && r.enabled !== false; });

  // priority sort: LOWER runs first (ascending)
  parsed.sort(function (a, b) {
    var pa = Number(a.priority || 0);
    var pb = Number(b.priority || 0);
    return pa - pb;
  });

  jcgRefs.rules = parsed;

  jcgTrace('initRefs', {
    rulesLen: jcgRefs.rules.length,
    giftCap: jcgRefs.giftCap,
    customerLogged: jcgRefs.customerLogged,
    globalDebug: jcgRefs.globalDebug
  });
}

function jcgGetData() {
  jcgInitRefs();
  return {
    container: jcgRefs.container,
    rules: jcgRefs.rules || [],
    giftCap: jcgRefs.giftCap || 0,
    customerLogged: jcgRefs.customerLogged,
    globalDebug: jcgRefs.globalDebug
  };
}

function jcgIsRuleConfigured(rule) {
  if (!rule) return false;

  var hasTrigger =
    (rule.trigger_type === 'product' && Number(rule.trigger_product_id) > 0) ||
    (rule.trigger_type === 'collection' && String(rule.trigger_collection_handle || '').length > 0);

  var hasGift =
    (rule.gift_type === 'product' && Number(rule.gift_variant_id) > 0) ||
    (rule.gift_type === 'collection' && String(rule.gift_collection_url || '').length > 0);

  return hasTrigger && hasGift;
}

/* ===== 3) HELPERS ===== */
function jcgEmit(detail) {
  var names = [
    'jcg:gifts',
    'cart:updated', 'cart:change', 'cart:refresh',
    't4s:cart:updated', 't4s:cart:change'
  ];
  names.forEach(function (name) {
    try {
      var e = new CustomEvent(name, { detail: detail });
      document.dispatchEvent(e);
      window.dispatchEvent(e);
    } catch (_) {
      var e2 = document.createEvent('Event');
      e2.initEvent(name, true, true);
      document.dispatchEvent(e2);
      window.dispatchEvent(e2);
    }
  });
}

function jcgIsGiftLine(item) {
  if (!item) return false;
  var p = item.properties || {};
  return (p._jcg_gift === 1 || p._jcg_gift === '1' || p._jcg_gift === true || p._jcg_gift === 'true');
}

function jcgIsPaidLine(item) {
  return !jcgIsGiftLine(item);
}

function jcgCountPaidQtyByHandle(cart, handle) {
  var h = String(handle || '').toLowerCase();
  if (!h) return 0;
  var sum = 0;
  (cart.items || []).forEach(function (i) {
    if (!jcgIsPaidLine(i)) return;
    if (String(i.handle || '').toLowerCase() === h) sum += Number(i.quantity || 0);
  });
  return sum;
}

function jcgCountGiftQtyByRule(cart, ruleId) {
  var id = String(ruleId || '');
  if (!id) return 0;
  var sum = 0;
  (cart.items || []).forEach(function (i) {
    if (!jcgIsGiftLine(i)) return;
    var p = i.properties || {};
    if (String(p._jcg_rule || '') === id) sum += Number(i.quantity || 0);
  });
  return sum;
}

function jcgCountTotalGifts(cart) {
  var sum = 0;
  (cart.items || []).forEach(function (i) {
    if (!jcgIsGiftLine(i)) return;
    sum += Number(i.quantity || 0);
  });
  return sum;
}

function jcgAccessAllowed(access, customerLogged) {
  var a = String(access || 'everyone');
  if (a === 'everyone') return true;
  if (a === 'logged') return !!customerLogged;
  if (a === 'general') return !customerLogged;
  return true;
}

/* ===== 4) COLLECTION HANDLE CACHE ===== */
var __jcgCollectionProductsCache = {};

function jcgGetCollectionHandles(collectionHandle) {
  var ch = String(collectionHandle || '').toLowerCase();
  if (!ch) return Promise.resolve([]);
  if (__jcgCollectionProductsCache[ch]) return Promise.resolve(__jcgCollectionProductsCache[ch]);

  var url = '/collections/' + encodeURIComponent(ch) + '/products.json?limit=250';
  return fetch(url, { credentials: 'same-origin' })
    .then(function (r) { return r.json(); })
    .then(function (json) {
      var products = (json && json.products) ? json.products : [];
      var handles = products.map(function (p) { return String(p.handle || '').toLowerCase(); }).filter(Boolean);
      __jcgCollectionProductsCache[ch] = handles;
      return handles;
    })
    .catch(function (e) {
      __jcgCollectionProductsCache[ch] = [];
      jcgLog('warn', 'collection fetch failed', ch, e);
      return [];
    });
}

/* ===== 5) VARIANT HYDRATION (fallback) ===== */
var __jcgProductVariantCache = {};

function jcgGetDefaultVariantIdForHandle(handle) {
  var h = String(handle || '').toLowerCase();
  if (!h) return Promise.resolve(null);
  if (__jcgProductVariantCache[h]) return Promise.resolve(__jcgProductVariantCache[h]);

  return fetch('/products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
    .then(function (r) { return r.json(); })
    .then(function (prod) {
      var v = null;
      var vs = (prod && prod.variants) ? prod.variants : [];
      for (var i = 0; i < vs.length; i++) {
        if (vs[i] && vs[i].available) { v = vs[i]; break; }
      }
      var id = v ? String(v.id) : null;
      __jcgProductVariantCache[h] = id;
      return id;
    })
    .catch(function () {
      __jcgProductVariantCache[h] = null;
      return null;
    });
}

/* ===== 6) CART MUTATIONS ===== */
function jcgAddGift(variantId, qty, ruleId) {
  var v = String(variantId || '');
  var q = Number(qty || 0);
  if (!v || q <= 0) return Promise.resolve(null);

  jcgTrace('addGift', { variantId: v, qty: q, ruleId: ruleId });

  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    credentials: 'same-origin',
    body: JSON.stringify({
      id: v,
      quantity: q,
      properties: { _jcg_gift: '1', _jcg_rule: String(ruleId || ''), _source: 'minicart' }
    })
  }).then(function (res) {
    return res.text().then(function (text) {
      var json = null; try { json = JSON.parse(text); } catch (_) {}
      if (!res.ok) throw new Error('Add failed: ' + res.status + ' ' + text);
      jcgEmit({ stage: 'added', ruleId: ruleId, added: json });
      jcgShowToast('Gift added automatically.');
      return json;
    });
  });
}

function jcgChangeLineByKey(lineKey, qty) {
  var key = String(lineKey || '');
  var q = Number(qty || 0);
  if (!key) return Promise.resolve(null);

  return fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    credentials: 'same-origin',
    body: JSON.stringify({ id: key, quantity: q })
  }).then(function (r) { return r.json(); })
    .catch(function () { return null; });
}

function jcgReduceGiftsTo(cart, ruleId, targetQty) {
  var id = String(ruleId || '');
  var target = Number(targetQty || 0);

  var lines = [];
  (cart.items || []).forEach(function (i) {
    if (!jcgIsGiftLine(i)) return;
    var p = i.properties || {};
    if (String(p._jcg_rule || '') === id) lines.push(i);
  });

  var current = 0;
  lines.forEach(function (l) { current += Number(l.quantity || 0); });

  if (current <= target) return Promise.resolve();

  var toRemove = current - target;
  jcgTrace('reduceGifts', { ruleId: id, current: current, target: target, remove: toRemove });

  var chain = Promise.resolve();
  for (var i = 0; i < lines.length; i++) {
    (function (line) {
      chain = chain.then(function () {
        if (toRemove <= 0) return;
        var q = Number(line.quantity || 0);
        var newQ = q;
        if (q <= toRemove) { newQ = 0; toRemove -= q; }
        else { newQ = q - toRemove; toRemove = 0; }
        return jcgChangeLineByKey(line.key, newQ);
      });
    })(lines[i]);
  }

  return chain.then(function () {
    jcgEmit({ stage: 'reduced', ruleId: id, target: target });
  });
}

/* ===== 7) UI RENDER (MINI PANEL) ===== */
function jcgEnsurePanel(ruleId) {
  var c = jcgRefs.container;
  if (!c) return null;

  var pid = 'j_cg_panel_' + String(ruleId || '');
  var existing = document.getElementById(pid);
  if (existing) return existing;

  var wrap = document.createElement('div');
  wrap.className = 'j_cg-panel';
  wrap.id = pid;

  wrap.innerHTML = ''
    + '<div class="j_cg-panel-inner">'
    +   '<div class="j_cg-msg"></div>'
    +   '<div class="j_cg-actions"></div>'
    + '</div>';

  c.appendChild(wrap);
  return wrap;
}

function jcgSetPanelHidden(panel, hidden) {
  if (!panel) return;
  if (hidden) {
    panel.setAttribute('hidden', '');
    panel.setAttribute('aria-hidden', 'true');
  } else {
    panel.removeAttribute('hidden');
    panel.setAttribute('aria-hidden', 'false');
  }
}

function jcgRenderPanelForRule(rule, state) {
  var panel = jcgEnsurePanel(rule.id);
  if (!panel) return;

  var msg = panel.querySelector('.j_cg-msg');
  var actions = panel.querySelector('.j_cg-actions');
  if (!msg || !actions) return;

  actions.innerHTML = '';

  if (!state || state.visible !== true) {
    jcgSetPanelHidden(panel, true);
    return;
  }

  jcgSetPanelHidden(panel, false);

  var title = '<strong>Free gift available</strong>';
  var qtyLine = 'Eligible: ' + state.eligibleQty + ' | Gift: ' + state.desiredQty;
  if (state.reason === 'cap') qtyLine = 'Eligible: ' + state.eligibleQty + ' | Gift: 0 (cap reached)';

  msg.innerHTML = title + '<br>' + qtyLine;

  if (rule.gift_type === 'collection' && rule.gift_collection_url) {
    var a = document.createElement('a');
    a.className = 'j_cg-choose';
    a.href = rule.gift_collection_url;
    a.textContent = rule.gift_collection_cta || 'Choose your free gift';
    a.setAttribute('aria-label', a.textContent);
    actions.appendChild(a);
    return;
  }

  // Product gift
  // Product gift
    if (rule.gift_type === 'product') {
    // If auto-add, do not show a panel. Toast will confirm.
    if (rule.auto_add) {
        jcgSetPanelHidden(panel, true);
        return;
    }

    // Manual add button
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'j_cg-add';
    btn.textContent = 'Add gift';
    btn.setAttribute('data-jcg-add', '1');
    btn.setAttribute('data-rule-id', String(rule.id));
    btn.setAttribute('data-variant-id', String(rule.gift_variant_id || ''));
    actions.appendChild(btn);
    }

}

/* ===== 8) ELIGIBILITY (TRIGGER) ===== */
function jcgComputeEligibleUnits(cart, rule) {
  if (!rule) return Promise.resolve(0);

  // product trigger
  if (rule.trigger_type === 'product') {
    var paidQty = jcgCountPaidQtyByHandle(cart, rule.trigger_product_handle);
    return Promise.resolve(Math.floor(paidQty / 1));
  }

  // collection trigger
  if (rule.trigger_type === 'collection') {
    return jcgGetCollectionHandles(rule.trigger_collection_handle).then(function (handles) {
      if (!handles || !handles.length) return 0;

      var totalPaidQty = 0;
      (cart.items || []).forEach(function (i) {
        if (!jcgIsPaidLine(i)) return;
        var h = String(i.handle || '').toLowerCase();
        if (handles.indexOf(h) !== -1) totalPaidQty += Number(i.quantity || 0);
      });

      return Math.floor(totalPaidQty / 1);
    });
  }

  return Promise.resolve(0);
}

/* ===== 9) DESIRED GIFT QTY (ALLOW MULTIPLE, RULE CAP, GLOBAL CAP) ===== */
function jcgComputeDesiredGiftQty(cart, rule, eligibleUnits, globalCapTotal) {
  var allowMulti = (rule.allow_multiple === true);
  var ruleCap = (rule.gift_cap != null) ? Number(rule.gift_cap) : null;
  if (ruleCap != null && isNaN(ruleCap)) ruleCap = null;

  var desired = allowMulti ? Number(eligibleUnits || 0) : (eligibleUnits > 0 ? 1 : 0);

  // per-rule cap
  if (ruleCap != null && ruleCap >= 0) desired = Math.min(desired, ruleCap);

  // global cap
  var currentTotalGifts = jcgCountTotalGifts(cart);
  var currentThisRule = jcgCountGiftQtyByRule(cart, rule.id);

  var cap = Number(globalCapTotal || 0);
  var capLeft = (cap > 0) ? Math.max(0, cap - (currentTotalGifts - currentThisRule)) : 999999;

  desired = Math.min(desired, capLeft);

  return { desired: desired, capLeft: capLeft };
}

/* ===== 10) APPLY RULE (ADD OR REMOVE) ===== */
function jcgEnsureGiftVariant(rule) {
  if (!rule) return Promise.resolve(rule);
  if (rule.gift_type !== 'product') return Promise.resolve(rule);

  if (Number(rule.gift_variant_id) > 0) return Promise.resolve(rule);

  // fallback: try to derive from handle if provided
  if (rule.gift_product_handle) {
    return jcgGetDefaultVariantIdForHandle(rule.gift_product_handle).then(function (vid) {
      if (vid) rule.gift_variant_id = Number(vid);
      return rule;
    });
  }

  return Promise.resolve(rule);
}

function jcgApplyRule(cart, rule, globalCap, customerLogged) {
  if (!rule || rule.enabled === false) return Promise.resolve(cart);

  // access control
  if (!jcgAccessAllowed(rule.access, customerLogged)) {
    // If rule not accessible, remove any gifts previously added by this rule
    return jcgReduceGiftsTo(cart, rule.id, 0).then(function () {
      jcgTrace('rule removed due to access', rule.id, rule.access);
      return cart;
    });
  }

  // config safety
  if (!jcgIsRuleConfigured(rule)) {
    if (rule.debug) jcgTrace('Rule skipped (missing trigger or gift)', rule);
    return Promise.resolve(cart);
  }

  return jcgComputeEligibleUnits(cart, rule).then(function (eligibleUnits) {
    if (rule.debug) jcgTrace('rule eligibility', rule.id, { eligibleUnits: eligibleUnits });

    // Not eligible, remove gifts for this rule
    if (!eligibleUnits || eligibleUnits <= 0) {
      return jcgReduceGiftsTo(cart, rule.id, 0).then(function () {
        jcgRenderPanelForRule(rule, { visible: false });
        return cart;
      });
    }

    // If gift is collection choice, we do not auto-add. We only show UI.
    if (rule.gift_type === 'collection') {
      jcgRenderPanelForRule(rule, {
        visible: true,
        eligibleQty: eligibleUnits,
        desiredQty: 1,
        reason: 'choice'
      });
      // Also remove any existing gifts for this rule (keeps things consistent)
      return jcgReduceGiftsTo(cart, rule.id, 0).then(function () { return cart; });
    }

    // Gift is product
    return jcgEnsureGiftVariant(rule).then(function () {
      var computed = jcgComputeDesiredGiftQty(cart, rule, eligibleUnits, globalCap);
      var desiredQty = computed.desired;
      var currentGiftQty = jcgCountGiftQtyByRule(cart, rule.id);

      if (rule.debug) {
        jcgLog('info', 'rule state', rule.id, {
          eligibleUnits: eligibleUnits,
          desiredQty: desiredQty,
          currentGiftQty: currentGiftQty,
          autoAdd: !!rule.auto_add,
          allowMultiple: !!rule.allow_multiple,
          capLeft: computed.capLeft
        });
      }

      jcgRenderPanelForRule(rule, {
        visible: true,
        eligibleQty: eligibleUnits,
        desiredQty: desiredQty,
        reason: (desiredQty === 0 && computed.capLeft === 0) ? 'cap' : 'ok'
      });

      var variantId = String(rule.gift_variant_id || '');
      if (!variantId) {
        if (rule.debug) jcgLog('warn', 'gift product missing variant_id', rule.id);
        return jcgReduceGiftsTo(cart, rule.id, 0).then(function () { return cart; });
      }

      // Reduce if too many
      if (currentGiftQty > desiredQty) {
        return jcgReduceGiftsTo(cart, rule.id, desiredQty).then(function () { return cart; });
      }

      // Add if missing and auto add enabled
      if (currentGiftQty < desiredQty) {
        if (!rule.auto_add) return cart;
        var toAdd = desiredQty - currentGiftQty;

        if (rule.debug) jcgLog('info', 'auto-add gifts', rule.id, { variantId: variantId, qty: toAdd });

        return jcgAddGift(variantId, toAdd, rule.id)
          .then(function () { return jcgGetCart(); })
          .catch(function (e) {
            jcgLog('error', 'auto-add failed', rule.id, e);
            return cart;
          });
      }

      return cart;
    });
  });
}

/* ===== 11) MAIN REFRESH ===== */
var __jcgIsRunning = false;
var __jcgLastRunAt = 0;

function jcgRefresh(force) {
  var now = Date.now();
  if (!force && now - __jcgLastRunAt < 120) return;
  __jcgLastRunAt = now;

  if (__jcgIsRunning) { jcgTrace('refresh skipped (in flight)'); return; }
  __jcgIsRunning = true;

  jcgInitRefs(true);
  var data = jcgGetData();
  if (!data.container || !data.rules.length) {
    __jcgIsRunning = false;
    return;
  }

  jcgGetCart().then(function (cart) {
    var rules = data.rules;
    var globalCap = Number(data.giftCap || 0);
    var customerLogged = !!data.customerLogged;

    jcgTrace('refresh start', {
      item_count: cart.item_count,
      totalGifts: jcgCountTotalGifts(cart),
      globalCap: globalCap,
      rulesLen: rules.length
    });

    var chain = Promise.resolve(cart);

    for (var i = 0; i < rules.length; i++) {
      (function (rule) {
        chain = chain.then(function (cSnapshot) {
          // If cap reached, we still remove gifts when trigger disappears,
          // but we block new additions for lower-priority rules.
          var totalGifts = jcgCountTotalGifts(cSnapshot);
          if (globalCap > 0 && totalGifts >= globalCap) {
            if (rule.debug) jcgLog('warn', 'global cap reached', { globalCap: globalCap, totalGifts: totalGifts, blockedRule: rule.id });

            return jcgComputeEligibleUnits(cSnapshot, rule).then(function (eligibleUnits) {
              if (!eligibleUnits || eligibleUnits <= 0) {
                return jcgReduceGiftsTo(cSnapshot, rule.id, 0).then(function () { return cSnapshot; });
              }

              jcgRenderPanelForRule(rule, {
                visible: true,
                eligibleQty: eligibleUnits,
                desiredQty: 0,
                reason: 'cap'
              });

              return cSnapshot;
            });
          }

          return jcgApplyRule(cSnapshot, rule, globalCap, customerLogged);
        });
      })(rules[i]);
    }

    return chain.then(function () {
      jcgTrace('refresh done');
    });

  }).catch(function (e) {
    jcgLog('error', 'jcgRefresh failed', e);
  }).finally(function () {
    __jcgIsRunning = false;
  });
}

/* ===== 12) MANUAL ADD BUTTON HANDLER ===== */
function jcgBindManualAdd() {
  document.body.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-jcg-add="1"]') : null;
    if (!btn) return;

    e.preventDefault();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    e.stopPropagation();

    var ruleId = btn.getAttribute('data-rule-id') || '';
    var variantId = btn.getAttribute('data-variant-id') || '';

    if (!variantId) {
      jcgLog('warn', 'manual add missing variant id', ruleId);
      return;
    }

    var prev = btn.disabled;
    btn.disabled = true;

    jcgAddGift(variantId, 1, ruleId)
      .then(function () {
        jcgEmit({ stage: 'manual-added', ruleId: ruleId, variantId: variantId });
        jcgDebouncedRefresh(180);
      })
      .catch(function (e2) {
        jcgLog('error', 'manual add failed', ruleId, e2);
      })
      .finally(function () {
        btn.disabled = prev;
      });
  }, true);
}

/* ===== 13) EVENT LISTENERS ===== */
var __jcgListenersAttached = false;

function jcgAttachListeners() {
  if (__jcgListenersAttached) return;
  __jcgListenersAttached = true;

  var names = [
    'cart:updated', 'cart:change', 'cart:refresh',
    't4s:cart:updated', 't4s:cart:change',
    'ajaxCart:updated', 'ajaxProduct:added',
    'added.ajaxProduct', 'removed.ajaxProduct'
  ];

  names.forEach(function (n) {
    document.addEventListener(n, function () {
      jcgDebouncedRefresh(120);
    }, { passive: true });
  });
}

/* ===== 14) DIAGNOSTIC INSPECTOR ===== */
window.__jcgDiag = function () {
  var el = document.querySelector('.j_cg-container');
  var info = {
    hasContainer: !!el,
    giftCap: el && el.dataset ? el.dataset.giftCap : null,
    customerLogged: el && el.dataset ? el.dataset.customerLogged : null,
    debug: el && el.dataset ? el.dataset.debug : null,
    rulesRaw: el && el.dataset ? el.dataset.rules : null,
    rulesParsed: [],
    panels: []
  };
  try {
    info.rulesParsed = el && el.dataset && el.dataset.rules ? JSON.parse(el.dataset.rules) : [];
  } catch (e) {
    info.parseError = String(e);
  }
  var panels = document.querySelectorAll('.j_cg-panel');
  for (var i = 0; i < panels.length; i++) info.panels.push(panels[i].id);
  console.log('[JCG:DIAG]', info);
  return info;
};

/* ===== 15) BOOT ===== */
document.addEventListener('DOMContentLoaded', function () {
  jcgInitRefs(true);
  jcgAttachListeners();
  jcgBindManualAdd();
  jcgRefresh(true);
});

/******* END *******/

